export const EVENT_MAP: Record<
  string,
  { prova: string; horas: string; title: string }
> = {
  '2671D216-A1F5-4958-9631-93A0662E7CB6': {
    prova: 'Colégios Agrícolas',
    horas: '03h00',
    title: `<div
              style="background: #fff; display: flex; justify-content: center; align-items: center; height: 100%; border-radius: 5px;">
              <img
                src="https://storage.googleapis.com/imagens_propostas_prod_redacao_2_0/Outros/CredenciamentoDiretores/col_agricola_sf.png"
                alt="agricola" style="width: 140px;">
            </div>
            `,
  },
  '9DA0F41A-CBA4-4655-A7EC-CC4C6A984E03': {
    prova: 'Colégios Cívico Militares',
    horas: '03h00',
    title: `<div
              style="background: #fff; display: flex; justify-content: center; align-items: center; height: 100%; border-radius: 5px;">
              <img
                src="https://storage.googleapis.com/imagens_propostas_prod_redacao_2_0/Outros/CredenciamentoDiretores/col_civ_militar_sf_v3.png"
                alt="civico_militar" style="width: 95px;">
            </div>
            `,
  },
  'B6BC900C-DB95-48CC-86CF-286D8A1ABFFC': {
    prova: 'Parceiros da Escola',
    horas: '03h00',
    title: `<div
              style="background: #fff; display: flex; justify-content: center; align-items: center; height: 100%; border-radius: 5px;">
              <img
                src="https://storage.googleapis.com/imagens_propostas_prod_redacao_2_0/Outros/CredenciamentoDiretores/col_parceiro_sf.png"
                alt="parceiro" style="width: 170px;">
            </div>
            `,
  },
  '5A6356A2-7BEB-44EF-A798-82CDF85D196D': {
    prova: 'Paraná Integral',
    horas: '03h00',
    title: `<div
              style="background: #fff; display: flex; justify-content: center; align-items: center; height: 100%; border-radius: 5px;">
              <img
                src="https://storage.googleapis.com/imagens_propostas_prod_redacao_2_0/Outros/CredenciamentoDiretores/col_integral_sf.png"
                alt="integral" style="width: 140px;">
            </div>
            `,
  },
  '170FA595-AC1A-4181-8339-AF6D49BA65B7': {
    prova: 'Colégios Agrícolas + Cívico Militares',
    horas: '04h00',
    title: `<div
              style="background: #fff; display: flex; justify-content: center; align-items: center; height: 100%; border-radius: 5px;">
              <img
                src="https://storage.googleapis.com/imagens_propostas_prod_redacao_2_0/Outros/CredenciamentoDiretores/col_agricola_sf.png"
                alt="agricola" style="width: 140px;">
              <span style="font-size: 36px; color: #7356B2; padding-left: 10px">+</span>
              <img
                src="https://storage.googleapis.com/imagens_propostas_prod_redacao_2_0/Outros/CredenciamentoDiretores/col_civ_militar_sf_v3.png"
                alt="civico_militar" style="width: 95px;">
            </div>`,
  },
  'E23EA8CC-697D-4C1B-9719-0BE958DDF2AA': {
    prova: 'Colégios Agrícolas + Parceiros da Escola',
    horas: '04h00',
    title: `<div
              style="background: #fff; display: flex; justify-content: center; align-items: center; height: 100%; border-radius: 5px;">
              <img
                src="https://storage.googleapis.com/imagens_propostas_prod_redacao_2_0/Outros/CredenciamentoDiretores/col_agricola_sf.png"
                alt="agricola" style="width: 140px;">
              <span style="font-size: 36px; color: #7356B2; padding-left: 10px">+</span>
              <img
                src="https://storage.googleapis.com/imagens_propostas_prod_redacao_2_0/Outros/CredenciamentoDiretores/col_parceiro_sf.png"
                alt="parceiro" style="width: 170px;">
            </div>`,
  },
  'DF2BBEF8-6711-49DA-BEEC-F0E505B03A6D': {
    prova: 'Colégios Agrícolas + Paraná Integral',
    horas: '04h00',
    title: `<div
              style="background: #fff; display: flex; justify-content: center; align-items: center; height: 100%; border-radius: 5px;">
              <img
                src="https://storage.googleapis.com/imagens_propostas_prod_redacao_2_0/Outros/CredenciamentoDiretores/col_agricola_sf.png"
                alt="agricola" style="width: 140px;">
              <span style="font-size: 36px; color: #7356B2; padding-left: 10px">+</span>
              <img
                src="https://storage.googleapis.com/imagens_propostas_prod_redacao_2_0/Outros/CredenciamentoDiretores/col_integral_sf.png"
                alt="integral" style="width: 140px;">
            </div>`,
  },
  '6834FE06-E45A-4AD4-8613-15845A88D070': {
    prova: 'Colégios Cívico Militares + Parceiros da Escola',
    horas: '04h00',
    title: `<div
              style="background: #fff; display: flex; justify-content: center; align-items: center; height: 100%; border-radius: 5px;">
              <img
                src="https://storage.googleapis.com/imagens_propostas_prod_redacao_2_0/Outros/CredenciamentoDiretores/col_civ_militar_sf_v3.png"
                alt="civico_militar" style="width: 95px;">
              <span style="font-size: 36px; color: #7356B2; padding-left: 10px">+</span>
              <img
                src="https://storage.googleapis.com/imagens_propostas_prod_redacao_2_0/Outros/CredenciamentoDiretores/col_parceiro_sf.png"
                alt="parceiro" style="width: 170px;">
            </div>`,
  },
  '7006F282-800F-4BFC-8846-6571E7B27030': {
    prova: 'Colégios Cívico Militares + Paraná Integral',
    horas: '04h00',
    title: `<div
              style="background: #fff; display: flex; justify-content: center; align-items: center; height: 100%; border-radius: 5px;">
              <img
                src="https://storage.googleapis.com/imagens_propostas_prod_redacao_2_0/Outros/CredenciamentoDiretores/col_civ_militar_sf_v3.png"
                alt="civico_militar" style="width: 95px;"> <span style="font-size: 36px; color: #7356B2; padding-left: 10px">+</span> <img
                src="https://storage.googleapis.com/imagens_propostas_prod_redacao_2_0/Outros/CredenciamentoDiretores/col_integral_sf.png"
                alt="integral" style="width: 140px;">
            </div>`,
  },
  '2098E347-3D16-4733-8D18-2A91160176E9': {
    prova: 'Parceiros da Escola + Paraná Integral',
    horas: '04h00',
    title: `<div
              style="background: #fff; display: flex; justify-content: center; align-items: center; height: 100%; border-radius: 5px;">
              <img
                src="https://storage.googleapis.com/imagens_propostas_prod_redacao_2_0/Outros/CredenciamentoDiretores/col_parceiro_sf.png"
                alt="parceiro" style="width: 170px;">
              <span style="font-size: 36px; color: #7356B2; padding-left: 10px">+</span>
              <img
                src="https://storage.googleapis.com/imagens_propostas_prod_redacao_2_0/Outros/CredenciamentoDiretores/col_integral_sf.png"
                alt="integral" style="width: 140px;">
            </div>`,
  },
};

export const DESCRIPTION = {
  description: `<div
                  style="font-family: 'Roboto', sans-serif; max-width: 700px; margin: 0 auto; padding: 10px; color: #374151; line-height: 1.8; font-size: 11pt;">
                  <p style="margin: 0 0 16px 0;">
                    Professor(a), <strong style="color: #667eea;">#nome#</strong>, você está prestes a iniciar a sua prova de
                    Credenciamento para Diretores da Rede Pública
                    Estadual
                    de Ensino do Paraná – Edital N.°17/2026 GS/SEED, para o programa:
                  </p>
                  <ul style="margin: 0 0 16px 0; padding-left: 20px; color: #4b5563;">
                    <li>  <strong style="color: #667eea;"> ➡️ #prova#</strong> </li>
                  </ul>
                  <p style="margin: 0 0 4px 0;">
                    1. A prova será realizada <strong>online</strong> no dia <strong>30 de abril de 2026</strong>,
                    com início às <strong>08h00</strong>, e terá duração de <strong>#horas#</strong>.
                  </p>
                  <p style="margin: 0 0 4px 0;">
                    2. Aos que solicitaram prova com adaptação terão a disponibilidade de 01 hora a mais para a realização da prova.
                  </p>
                  <p style="margin: 0 0 4px 0;">
                    3. É proibido o uso de materiais de consulta e aparelhos eletrônicos pessoais (smartphones, tablets), bem como
                    qualquer
                    contato entre os candidatos.
                  </p>
                  <div
                    style="border: 1px solid #f59e0b; border-left: 4px solid #f59e0b; border-radius: 8px; padding: 14px 18px; margin-top: 16px; margin-bottom: 16px; font-size: 10.5pt; line-height: 1.7;">
                    <strong style="font-size: 11pt;">Recomendações:</strong>
                    <br />
                    <span style="display: block; margin-top: 6px;">
                      a) Abra a plataforma em <strong>apenas uma aba do navegador</strong> — manter múltiplas abas abertas
                      pode causar <strong>instabilidade no sistema</strong> e comprometer o registro correto das suas respostas;
                    </span>
                    <span style="display: block; margin-top: 6px;">
                      b) Para melhor utilização da plataforma, recomendamos o uso de telas maiores, de preferência no
                      <strong>computador</strong>;
                    </span>
                    <span style="display: block; margin-top: 6px;">
                      c) O aplicador disponibilizará uma <strong>folha de sulfite</strong> para que você registre seu gabarito.
                      À medida que avançar nas respostas, utilize-a para preservar suas escolhas — assim, se precisar retornar ao sistema,
                      suas respostas estarão preservadas;
                    </span>
                    <span style="display: block; margin-top: 6px;">
                      d) Após o envio da prova, ao receber a confirmação <strong>"Respostas enviadas com sucesso!"</strong>, acesse o
                      menu <strong>Visualizar</strong> no topo da página para consultar todas as questões respondidas;
                    </span>
                    <span style="display: block; margin-top: 6px;">
                      e) Após o envio da prova e <b>ANTES DE DESLOGAR</b>, é preciso que chame o aplicador para validação do envio.
                    </span>
                  </div>
                  <p>O botão que habilita a prova só será disponibilizado após clicar na opção de “li e concordo” comprovando que esta
                    ciente das orientações acima.</p>
                  <p style="margin: 0; font-size: 11pt; color: #374151;"> <strong>Boa sorte e tenha uma excelente prova!</strong> </p>
                </div>
                `,
};

export const getFuncao = (funcaoId: string) => {
  const funcoes: Record<string, string> = {
    'ECC5AA6E-EA1C-4F73-BA17-31140C7E248E': 'DIAGNOSTIC EXAM',
    '01C5BC6A-6F04-4D6C-9838-C874273B62BA': 'PROVA TESTE',
    '2671D216-A1F5-4958-9631-93A0662E7CB6': 'COLÉGIOS AGRÍCOLAS',
    '9DA0F41A-CBA4-4655-A7EC-CC4C6A984E03': 'COLÉGIOS CÍVICO MILITARES',
    'B6BC900C-DB95-48CC-86CF-286D8A1ABFFC': 'PARCEIROS DA ESCOLA',
    '5A6356A2-7BEB-44EF-A798-82CDF85D196D': 'PARANÁ INTEGRAL',
    '170FA595-AC1A-4181-8339-AF6D49BA65B7':
      'COLÉGIOS AGRÍCOLAS + CÍVICO MILITARES',
    'E23EA8CC-697D-4C1B-9719-0BE958DDF2AA':
      'COLÉGIOS AGRÍCOLAS + PARCEIROS DA ESCOLA',
    'DF2BBEF8-6711-49DA-BEEC-F0E505B03A6D':
      'COLÉGIOS AGRÍCOLAS + PARANÁ INTEGRAL',
    '6834FE06-E45A-4AD4-8613-15845A88D070':
      'COLÉGIOS CÍVICO MILITARES + PARCEIROS DA ESCOLA',
    '7006F282-800F-4BFC-8846-6571E7B27030':
      'COLÉGIOS CÍVICO MILITARES + PARANÁ INTEGRAL',
    '2098E347-3D16-4733-8D18-2A91160176E9':
      'PARCEIROS DA ESCOLA + PARANÁ INTEGRAL',
  };
  return funcoes[funcaoId.toUpperCase()] || funcaoId;
};
